<template>
  <div v-if="!mobile" class="login">
    <span class="ball ball-1"></span>
    <span class="ball ball-2"></span>
    <span class="ball ball-3"></span>
    <span class="ball ball-4"></span>
    <span class="ball ball-5"></span>
    <ul>
      <li>
        <span class="ball"></span>
      </li>
      <li>
        <span class="ball"></span>
      </li>
      <li>
        <span class="ball"></span>
      </li>
      <li>
        <span class="ball"></span>
      </li>
    </ul>
    <div class="login-content">
      <template v-if="step == 1">
        <div class="title">{{ '欢迎登录' }}</div>
        <div class="text-center mb-md">
          <el-radio-group v-model="loginMethod" class="login-type-radio-group" @change="handleTypeChange">
            <el-radio-button label="QR">扫码登录</el-radio-button>
            <el-radio-button label="PWD">账号登录</el-radio-button>
          </el-radio-group>
        </div>
        <el-form
          v-show="loginMethod == 'PWD'"
          :ref="loginForm"
          v-loading="loading"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          auto-complete="on"
          size="big"
          label-position="left"
        >
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="账号 / 手机"
              name="username"
              prefix-icon="el-icon-user"
              clearable
              type="text"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              placeholder="密码"
              name="password"
              prefix-icon="el-icon-lock"
              clearable
              type="password"
              @keyup.enter.native="handleLoginVerify"
            ></el-input>
          </el-form-item>

          <div class="text-right mb" style="margin-top: -16px;line-height: 28px;">
            <el-link :underline="false" @click="handlePassword">忘记密码</el-link>
          </div>

          <div class="mb">
            <el-button class="submit" type="primary" round :loading="posting" @click="handleLoginVerify">登 录</el-button>
          </div>

          <div v-if="aiot_register_enable" class="flex-center align-items-center">
            <span class="text-muted">没有账号？</span>
            <el-link type="primary" :underline="false" @click="handleRegister">立即注册</el-link>
          </div>
        </el-form>
        <div v-show="loginMethod === 'QR'">
          <div class="description mb-sm">
            <span v-if="errorMsg" class="text-danger">{{ errorMsg }}</span>
            <span v-else>请使用微信扫码登录</span>
          </div>
          <div v-loading="qrcodeLoading" class="img-box flex align-items-center justify-content-center">
            <el-image v-if="qrcodeImg" class="img" :src="qrcodeImg" alt="" />
            <div v-if="showMask" class="mask">
              <el-button class="is-registed-btn" type="text" @click="getCode">刷新二维码</el-button>
            </div>
          </div>
        </div>
      </template>
      <template v-if="step == 1.5">
        <div class="title">{{ '安全验证' }}</div>
        <el-alert :closable="false" type="warning" class="mb">
          <div slot="title" class="flex align-items-center">
            <i class="el-icon-warning-outline font-lg"></i>
            <span class="ml-sm">{{ '存在多个关联企业，请使用微信扫码进行身份安全验证' }}</span>
          </div>
        </el-alert>
        <div class="description mb-sm">
          <span v-if="errorMsg" class="text-danger">{{ errorMsg }}</span>
          <span v-else>请使用微信扫码验证</span>
        </div>
        <div v-loading="qrcodeLoading" class="img-box flex align-items-center justify-content-center">
          <el-image v-if="qrcodeImg" class="img" :src="qrcodeImg" alt="" />
          <div v-if="showMask" class="mask">
            <el-button class="is-registed-btn" type="text" @click="getCode">刷新二维码</el-button>
          </div>
        </div>
      </template>
      <template v-if="step == 2">
        <div class="title">{{ '选择企业' }}</div>
        <el-scrollbar v-loading="loading" :native="false" class="scrollbar-view v-only" view-class="el-scrollbar-view">
          <div v-for="(item, index) in list" :key="index" role="button" class="firm pt pl-md pr-md pb ml-sm mr-sm flex align-items-center" @click="handleLoginConfirm(item)">
            <el-image v-if="item.logo" class="image rounded" :src="item.logo" fit="contain"></el-image>
            <div v-else class="font-3x">
              <i class="iconfont icon-firm text-primary"></i>
            </div>
            <div class="bd ml-sm flex column text-left ellipsis">
              <div class="font-lg text-bold ellipsis">{{ item.short_name }}</div>
              <div class="text-muted ellipsis">{{ item.full_name }}</div>
            </div>
            <i class="el-icon-arrow-right text-muted ft font-2x ml-lg"></i>
          </div>
        </el-scrollbar>
      </template>
    </div>
    

    
    <div class="footer">
      <span>©{{ new Date().getFullYear() }} <a href="https://www.frippler.com/" target="_blank" class="footer-link">Frippler | 鱼漾智能科技（上海）有限公司</a></span>
      <span class="ml"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="footer-link">沪ICP备 16026565 号</a></span>
    </div>

  </div>
  <SuggestToPC v-else />
</template>

<script>
import { removeAccessToken } from "@/utils/cookie";
import { getManifest } from "@/utils/pwa";
import { getRegisterSettingApi, codeSendApi, getQrCodeLoginStatusApi } from '@/api/common/registerApi'
import { getQrcodeApi } from '@/api/ei/eiApi'
import { loginVerifyApi } from '@/api/common/loginApi'

export default {
  name: "Login",

  data() {
    return {
      loginMethod: "QR", // QR or PWD
      verify_code: '',
      qrcodeImg: '',
      qrcodeLoading: false,
      showMask: false,
      errorMsg: '',

      timer: null,
      step: 1,
      list: [],

      config: {
        login_bg: "",
        console_imgurl: "",
        console_title: "",
      },

      redirect: null,

      loading: false,
      posting: false,
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {},
      mq: null,
      mobile: false,

      aiot_register_enable: 0
    };
  },

  components: {
    SuggestToPC: () => import("@/views/common/components/SuggestToPC.vue"),
  },

  computed: {
    loginBackgroundImage() {
      return !this.config.login_bg ? "" : "url(" + this.config.login_bg + ")";
    },
  },

  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },

  async created() {
    this.fetchRegisterSetting()
    const { ticket } = this.$route.query;
    if (ticket) {
      const token = Buffer.from(ticket, "base64").toString("utf-8");
      removeAccessToken();
      const deviceid = this.$route.query.deviceid
      localStorage.setItem('__DEVICEID__', deviceid)
      this.quickLogin(token, deviceid);
      return;
    }
    // 从缓存取配置
    this.config.login_bg = localStorage.getItem("__LOGIN_BG__") || "";
    // this.config.login_title = localStorage.getItem('__LOGIN_TITLE__') || ''
    this.config.console_imgurl =
      localStorage.getItem("__CONSOLE_IMGURL__") || "";
    this.config.console_title = localStorage.getItem("__CONSOLE_TITLE__") || "";

    // 更新页眉
    if (this.config.console_imgurl) {
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "icon";
      link.href = this.config.console_imgurl;
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    if (this.config.console_title) {
      document.title = this.config.console_title;
    }

    getManifest()
    this.loginMethod = localStorage.getItem('__LOGIN_METHOD__') || 'QR'
    if (this.loginMethod == 'QR') {
      this.getCode()
      this.checkStaus()
    }
  },

  mounted() {
    this.mq = window.matchMedia('(max-width: 900px)')
    this.mq.addEventListener('change', this.checkDeviceType)
    this.checkDeviceType(this.mq)
  },

  beforeDestroy() {
    if (this.mq) {
      this.mq.removeEventListener('change', this.checkDeviceType)
    }

    if (this.timer) {
      clearInterval(this.timer)
    }
  },

  methods: {
    getCode() {
      this.qrcodeLoading = true
      this.resetQrcode()
      codeSendApi({
        verify_way: 2,
        scene: 4
      }).then((res) => {
        if (!res.errno) {
          this.verify_code = res.data.verify_code
          this.fetchQrcode()
        } else {
          this.qrcodeLoading = false
        }
      }).catch(() => {
        this.qrcodeLoading = false
      })
    },

    resetQrcode () {
      this.qrcodeImg = ''
      this.showMask = false
      this.errorMsg = ''
    },

    fetchQrcode () {
      this.qrcodeLoading = true
      getQrcodeApi({
        scene: `scene=4&code=${this.verify_code}`,
        path: 'pages/index/authorization',
        type: 'asst',
      }).then((res) => {
        if (!res.errno) {
          const base64 = btoa(String.fromCharCode(...new Uint8Array(res)));
          const imgUrl = `data:image/png;base64,${base64}`;
          this.qrcodeImg = imgUrl
          this.qrcodeLoading = false
          this.checkStaus()
        } else {
          this.qrcodeLoading = false
        }
      }).catch(() => {
        this.qrcodeLoading = false
      })
    },


    handleTypeChange () {
			this.errMessage = ''
			this.active = true
			if (this.loginMethod == "QR") {
				this.getCode()
				this.checkStaus()
			} else {
				clearInterval(this.timer)
			}
		},

    checkStaus() {
      if (this.timer) clearInterval(this.timer)
      var _this = this;
      this.timer = setInterval(() => {
        if (_this.verify_code) {
          getQrCodeLoginStatusApi({ verify_code: _this.verify_code }).then((res) => {
            if (!res.errno) {
              if (!res.data || (res.data && !res.data.list) || (res.data && res.data.list && !res.data.list.length)) return
              _this.$message.success('授权成功！')
              if (res.data.list.length == 1) {
                _this.handleLoginConfirm(res.data.list[0])
              } else {
                _this.list = res.data.list
                _this.posting = false
                _this.step = 2
              }
              clearInterval(this.timer)
            } else {
              _this.errorMsg = res.message
              _this.showMask = true
              clearInterval(this.timer)
            }
          }).catch(() => {
            _this.errorMsg = '获取二维码失败'
            _this.showMask = true
            clearInterval(this.timer)
          })
        }
			}, 1000)
    },
 
    fetchRegisterSetting () {
      getRegisterSettingApi().then((res) => {
        if (!res.errno) {
          this.aiot_register_enable = res.data.aiot_register_enable
        }
      })
    },

    handleLoginVerify() {
      this.posting = true
      const temp = {
        username: this.loginForm.username,
        password: this.loginForm.password
      }
      loginVerifyApi(temp).then((res) => {
        if (!res.errno) {
          if (res.data.need_verify) {
            this.posting = false
            this.step = 1.5
            this.getCode()
            this.checkStaus()
            this.$nextTick(() => {
              this.loginMethod = 'QR'
            })
          } else {
            this.list = res.data.list
            if (res.data.list.length == 1) {
              this.handleLoginConfirm(res.data.list[0])
            } else {
              this.posting = false
              this.step = 2
            }
          }
        } else {
          this.posting = false
          this.$message.error(res.message)
        }
      })
    },

    handleLoginConfirm(item) {
      const temp = {
        uid: item.uid,
        username: this.loginForm.username,
        password: this.loginForm.password,
        login_way: this.loginMethod == 'QR' ? 'qrcode' : 'pwd',
        verify_code: this.loginMethod == 'PWD' ? '' : this.verify_code
      }
      this.$store
        .dispatch("loginByUsernameAction", Object.assign({}, temp))
        .then((res) => {
          if (!res.errno) {
            // 登录成功时不取消loading
            localStorage.setItem('__LOGIN_METHOD__', this.loginMethod)
            this.$message.success(`欢迎登录，${ item.realname || item.username }`);
            this.$router.push({ path: this.redirect || "/" });
          } else {
            this.posting = false;
            this.$message.error(res.message);
          }
        });
    },

    async quickLogin(token) {
      this.posting = true;
      this.$store
        .dispatch("loginByQuickAction", { token: token })
        .then((res) => {
          if (!res.errno) {
            this.$store.commit("SET_SUPER_FAST_LOGIN", true)
            // 登录成功时不取消loading
            this.$router.push({ path: this.redirect || "/" })
          } else {
            this.posting = false;
            this.$message.error(res.message);
          }
        });
    },

    handlePassword() {
      this.$router.push("/password");
    },

    handleRegister() {
      this.$router.push("/register");
    },

    checkDeviceType(e) {
       if(e.matches && /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
         this.mobile = true
       } else {
         this.mobile = false
       }
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  background-color: #f9fffc;
  background-size: 100% auto;
  .ball {
    position: absolute;
    display: block;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-size: 100% auto;

    &.ball-1 {
      top: 300px;
      left: 160px;
      width: 140px;
      height: 140px;
      transform: rotate(-90deg);
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      opacity: 0.3;
    }
    &.ball-2 {
      top: 80px;
      left: 80px;
      width: 40px;
      height: 40px;
      transform: rotate(130deg);
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
    &.ball-3 {
      top: -190px;
      left: 50%;
      transform: translateX(-50%) rotate(-90deg);
      width: 320px;
      height: 320px;
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      opacity: 0.3;
    }
    &.ball-4 {
      top: 180px;
      right: 15%;
      width: 100px;
      height: 100px;
      transform: rotate(90deg);
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
    &.ball-5 {
      top: 50%;
      right: 60px;
      width: 120px;
      height: 120px;
      transform: rotate(-90deg);
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      opacity: 0.3;
    }
  }
  .login-content {
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: -2px 8px 50px 0px rgba(238, 240, 240, 1);
    min-width: 400px;
    height: 430px;
    z-index: 999;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-66%);
    text-align: center;
    padding: 40px;
    border-radius: 10px;
    /*-webkit-box-shadow: 0 0 5px rgba(255,255,255,.2);*/
    .el-input .el-input__inner {
      background-color: #fff !important;
    }
    .title {
      font-size: 28px;
      font-weight: bold;
      letter-spacing: 3px;
      margin-bottom: 30px;
    }
    .login-type-radio-group.el-radio-group {
			width: 100%;
			.el-radio-button {
				width: 50%;
				/deep/ .el-radio-button__inner {
					width: 100%;
          background-color: #fff;
				}
				/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
					color: #07c160;
					background-color: #fff;
					border-color: #07c160;
				}
			}
		}
    .submit {
      width: 100%;
      font-size: 18px;
    }
  }

  .description {
    height: 20px;
    font-size: 14px;
    color: #101010;
  }
  .img-box {
    position: relative;
    height: 200px;

    .img {
      width: 200px;
      height: 200px;
    }

    .mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
      opacity: 0.96;
    }
    .is-registed-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
  .firm {
    border: 1px solid rgba(220,224,231,1);
    border-radius: 10px;
  }
  .firm + .firm {
    margin-top: 15px;
  }
  .scrollbar-view {
    height: 280px;
  }
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    text-align: center;
    .footer-link {
      &:hover, &:focus {
        text-decoration: underline;
      }
    }
  }

  ul {
    width: 80vw;
    height: 80vw;
    margin: 40px auto;
    position: relative;
    list-style: none;

    li {
      border: 2px solid #ceedd79f;
      position: absolute;
      left: 50%;
      top: 60%;
      border-radius: 50%;
      transform: translate(-50%, -50%);
      box-sizing: border-box;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      animation-name: orbit;
    }
    li .ball {
      display: block;
      position: absolute;
      left: 0;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      background-size: 100% auto;
    }
    li:nth-child(1) {
      width: 30%;
      height: 30%;
      animation-duration: 14s;
    }
    li:nth-child(1) .ball {
      left: 20%;
      top: 6%;
      width: 20px;
      height: 20px;
      // opacity: 0.3;
    }
    &li:nth-child(2) {
      width: 50%;
      height: 50%;
      animation-duration: 16s;
    }
    li:nth-child(2) .ball {
      left: 75%;
      top: 6%;
      width: 40px;
      height: 40px;
      // opacity: 0.3;
    }
    li:nth-child(3) {
      width: 60%;
      height: 60%;
      animation-duration: 28s;
    }
    li:nth-child(3) .ball {
      width: 60px;
      height: 60px;
      left: 11%;
      top: 11%;
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
    li:nth-child(4) {
      width: 100%;
      height: 100%;
      animation-duration: 32s;
      margin-top: 8%;
    }
    li:nth-child(4) > .ball {
      width: 80px;
      height: 80px;
      left: 12%;
      top: 12%;
      transform: rotate(120deg);
      // animation: orbit 180s infinite linear;
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
  }

  @keyframes orbit {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
}
</style>
